import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.map.js";
export default {
  data() {
    return {
      dataFrom: {
        promotion: [],
        promotion2: []
      },
      modeType: false,
      modeType2: false,
      promotionList: [{
        value: 1,
        word: '单'
      }, {
        value: 2,
        word: '人'
      }, {
        value: 3,
        word: '元'
      }],
      promotionList2: [{
        value: 1,
        word: '单'
      }, {
        value: 2,
        word: '人'
      }, {
        value: 3,
        word: '元'
      }]
    };
  },
  computed: {
    dataRule() {
      return {
        name: [{
          required: true,
          message: this.$t('请输入') + this.$t('职级名称'),
          trigger: 'blur'
        }],
        type: [{
          required: true,
          message: this.$t('请选择') + this.$t('销售分佣方式'),
          trigger: 'change'
        }],
        proportion: [{
          required: true,
          message: this.$t('请输入') + this.$t('固定比例'),
          trigger: 'blur'
        }],
        add: [{
          required: true,
          message: this.$t('请选择') + this.$t('增员绑定'),
          trigger: 'change'
        }],
        proportion2: [{
          required: true,
          message: this.$t('请输入') + this.$t('增员比例'),
          trigger: 'blur'
        }],
        mode: [{
          required: true,
          message: this.$t('请选择') + this.$t('晋级方式'),
          trigger: 'change'
        }],
        mode2: [{
          required: true,
          message: this.$t('请选择') + this.$t('降级方式'),
          trigger: 'change'
        }],
        promotion: [{
          required: true,
          validator: this.validatePromotion,
          trigger: 'blur'
        }],
        promotion2: [{
          required: true,
          validator: this.validatePromotion2,
          trigger: 'blur'
        }]
      };
    }
  },
  methods: {
    validatePromotion(rule, value, callback) {
      let cont = this.validatePromotionFun('promotion');
      if (cont) {
        callback(new Error(cont));
      } else {
        callback();
      }
    },
    validatePromotion2(rule, value, callback) {
      let cont = this.validatePromotionFun('promotion2');
      if (cont) {
        callback(new Error(cont));
      } else {
        callback();
      }
    },
    validatePromotionFun(value) {
      if (this.dataFrom[value].length == 0) {
        return value == 'promotion' ? this.$t('请选择') + this.$t('晋级规则') : this.$t('请选择') + this.$t('降级规则');
        // callback(new Error(value=='promotion'?'请选择晋级规则':'请选择降级规则'));
      } else {
        let arr = [];
        let new_arr = value == 'promotion' ? this.promotionList : this.promotionList2;
        new_arr.map(item => {
          let num = this.dataFrom[value].filter(item2 => item2 == item.value);
          if (num.length != 0) {
            if (item.name && item.type && item.type2 && item.name2) {
              arr.push(item);
            }
          }
        });
        if (arr.length != this.dataFrom[value].length) {
          return value == 'promotion' ? this.$t('请完善') + this.$t('晋级规则') : this.$t('请完善') + this.$t('降级规则');
          // callback(new Error());
        } else {
          return '';
          // callback();
        }
      }
    },
    modeChange() {
      let arr = this.dataFrom.mode.filter(item => item == '2');
      this.modeType = arr.length > 0 ? true : false;
    },
    modeChange2() {
      let arr = this.dataFrom.mode2.filter(item => item == '2');
      this.modeType2 = arr.length > 0 ? true : false;
    },
    onSubmit() {
      this.$refs.dataFrom.validate(valid => {
        if (valid) {
          // let obj=this.dataFrom;
          // obj.customerId=this.infoObj.customerId;
          // obj.companyWorkerId=this.$route.params.id;
          // workersApply(obj).then(res=>{
          this.$message.success(this.$t('操作成功'));
          this.$router.go(-1);
          // });
        }
      });
    }
  }
};